export default __webpack_public_path__ + "static/media/image-home.c7a305c1.jpg";